<mat-toolbar>
  <span class="breadcrumb" routerLink="/pfa-interne">
    {{'Utilisateurs Hygie31' | uppercase}}
  </span>
  <mat-icon>chevron_right</mat-icon>
  @if (keycloakUser) {
  <span class="highlight">
    {{ !!keycloakUser.email ? keycloakUser.email : (!!keycloakUser.lastName && !!keycloakUser.firstName ? keycloakUser.lastName + ' ' + keycloakUser.firstName :
    keycloakUser.id) | uppercase }}
  </span>
  }
  <span class="spacer"></span>
</mat-toolbar>


<div class="content">
  <mat-form-field appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [ngModel]="globalFilter" (ngModelChange)="applyFilter($event)" #input />
    @if (globalFilter) {
    <button matSuffix mat-icon-button class="close-button" aria-label="Clear" (click)="applyFilter(globalFilter = '')">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

    <!-- Nom Column -->
    <ng-container matColumnDef="nom">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
      <td mat-cell *matCellDef="let element">
        {{element.nom}} </td>
    </ng-container>
    <!-- Code postal Column -->
    <ng-container matColumnDef="codePostal">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Code Postal</th>
      <td mat-cell *matCellDef="let element">{{element.cp}}</td>
    </ng-container>
    <!-- Ville Column -->
    <ng-container matColumnDef="ville">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
      <td mat-cell *matCellDef="let element">{{element.ville}}</td>
    </ng-container>
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
          [checked]="adherentsSelected.hasValue() && isAllSelected()"
          [indeterminate]="adherentsSelected.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()"
          (change)="$event ? adherentsSelected.toggle(row) : null" [checked]="adherentsSelected.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" colspan="12">Aucune donnée correspondant au filtre "{{input.value}}"</td>
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons>
  </mat-paginator>

  <div class="buttons-container">
    <span class="spacer"></span>
    <button mat-raised-button (click)="onSave()">
      <mat-icon>save</mat-icon>
      <span>ENREGISTRER</span>
    </button>
  </div>
</div>